import { createContext } from 'react'

type State = {
  victimPin: string | null
  setVictimPin: (pin: string | null) => void
  createdAt: Date | null
  setCreatedAt: (date: Date) => void
  tag: string | null
  setTag: (id: string) => void
  isAnonymous: boolean
  setIsAnonymous: (isReportAnonymous: boolean) => void
}

export const ReportFormContext = createContext<State>({
  victimPin: null,
  setVictimPin: () => undefined,
  createdAt: null,
  setCreatedAt: () => undefined,
  isAnonymous: true,
  setIsAnonymous: () => undefined,
  tag: null,
  setTag: () => undefined,
})
